import React, { Fragment } from 'react'
import { Modal } from '@infotech/base-components'
import { PrimaryButton, SecondaryButton } from '@infotech/uikit-button'
import isUndefined from 'lodash/isUndefined'

const HeaderComponent = ({ text = {} }) => text.title || ``

const FooterComponent = ({
  text = {},
  handleSave,
  toggle,
  disabled,
}) => (
  <Fragment>
    {!isUndefined(text.ok) && (
      <PrimaryButton
        onClick={handleSave}
        disabled={disabled}
      >
        { text.ok }
      </PrimaryButton>
    )}
    {
      !isUndefined(text.cancel) && (
        <SecondaryButton
          disabled={disabled}
          onClick={toggle}
        >
          { text.cancel }
        </SecondaryButton>
      )
    }
  </Fragment>
)

const ModalDialog = ({
  children,
  opened,
  close,
  handleSave,
  text,
  disabled,
}) => (
  <Modal
    headerComponent={HeaderComponent}
    footerComponent={FooterComponent}
    isOpen={opened}
    onToggle={close}
    opened={opened}
    handleSave={handleSave}
    text={text}
    disabled={disabled}
    modalClassName="equipment-field-widget-modal-add"
  >
    { children }
  </Modal>
)

export default ModalDialog
